import { frontendURL } from '../../helper/URLHelper';

export default {
  routes: [
    {
      path: frontendURL('auth/signup'),
      name: 'auth_signup',
      component: () => import('./Signup'),
      meta: { requireSignupEnabled: true },
    },
    {
      path: frontendURL('auth'),
      name: 'auth',
      component: () => import('./Auth'),
      children: [
        {
          path: 'confirmation',
          name: 'auth_confirmation',
          component: () => import('./Confirmation'),
          props: route => ({
            config: route.query.config,
            confirmationToken: route.query.confirmation_token,
            redirectUrl: route.query.route_url,
          }),
        },
        {
          path: 'password/edit',
          name: 'auth_password_edit',
          component: () => import('./PasswordEdit'),
          props: route => ({
            config: route.query.config,
            resetPasswordToken: route.query.reset_password_token,
            redirectUrl: route.query.route_url,
          }),
        },
        {
          path: 'reset/password',
          name: 'auth_reset_password',
          component: () => import('./ResetPassword'),
        },
        {
          path: 'reset/checkemail',
          name: 'auth_reset_check_email',
          component: () => import('./CheckEmail'),
        },
        {
          path: 'otp',
          name: 'auth_otp',
          component: () => import('./Otp'),
          props: true,
        },
      ],
    },
  ],
};
